import styled from 'styled-components';

export const ShowAllStyle = styled.div`
	text-align: center;

	button::after {
		vertical-align: middle;
	}
`;
